import { Locale } from "App";
import fr from "./fr.json";
import en from "./en.json";
export const locales: { [key in Locale]: Record<string, string> } = {
    fr,
    en
};